module.exports = __webpack_public_path__ + "img/sceneIcon1-4.214008a5.png";